module.exports = __webpack_public_path__ + "static/media/06_CORTININHA_SEM_BOJO_LISO_09.f3d4a493.jpg";